import React, { useRef } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./LiquidityPlanGlobal.styles";
import { downloadElementsAsPdf } from "../../common/Pdf/pdfDownloader";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const LiquidityPlanGlobal = ({ page } = {}) => {
  const { classes } = useStyles();
  const headerRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleDownloadMulti = () => {
    // Will be printed in separate pages, if need in single page do need conditional display none
    const elementsToPrint = [
      headerRef.current,
      contentRef.current,
      footerRef.current,
    ];

    downloadElementsAsPdf(elementsToPrint, "CombinedReport.pdf");
  };

  return (
    <div className={classes.page}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <Item>This is {page} component</Item>
          <div>
            <button onClick={handleDownloadMulti}>Download as PDF</button>

            <div
              ref={headerRef}
              style={{ border: "1px solid black", padding: "10px" }}
            >
              <h3>Header Section</h3>
            </div>

            <div
              ref={contentRef}
              style={{
                border: "1px solid black",
                padding: "10px",
                backgroundColor: "#E8E3E3",
              }}
            >
              <h3>Content Section</h3>
            </div>

            <div
              ref={footerRef}
              style={{ border: "1px solid black", padding: "10px" }}
            >
              <h3>Footer Section</h3>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default LiquidityPlanGlobal;
